import script from "./ThreeDContentBrowser.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreeDContentBrowser.vue?vue&type=script&setup=true&lang=ts"

import "./ThreeDContentBrowser.vue?vue&type=style&index=0&id=5a28f870&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a28f870"]])

export default __exports__